export const getRegexMatchResultText = <
  T extends string | undefined = string | undefined
>(
  matchResult: RegExpMatchArray | null
): T | undefined => {
  const match = matchResult ?? [];
  return match.length >= 3 ? (match[2] as T) : undefined;
};
